module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "adBar",
    staticClass: "footer"
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://live.aiyaopai.com/static/order_v2/index.html"
    }
  }, [_c('img', {
    staticClass: "footerIamge",
    attrs: {
      "src": "https://assets.aiyaopai.com/ad_2018.gif",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0589f9f8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdBar/AdBar.vue
// module id = 493
// module chunks = 1